export default __webpack_public_path__ + "static/media/10.ede66b3b.jpg";